import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import 'lm-ui-kit/src/components/uc-button/uc-button.define';
import { largeDesktop, tablet } from '../utils';

export class UcFooter extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        width: 100%;

        padding: ${pxToRem(10)} 0 ${pxToRem(30)};
        background: #f1f1f1;
        border-top: 5px solid #66c05d;
      }

      .content {
        display: flex;
        flex-direction: column;
      }

      ${tablet(css`
        :host {
          padding-top: ${pxToRem(40)};
        }
      `)}

      ${largeDesktop(css`
        .content {
          flex-direction: row;
        }

        ::slotted(uc-footer-menu) {
          flex: 1 1 70%;
        }
      `)}
    `;
  }

  render() {
    return html`
      <div class="content">
        <slot></slot>
      </div>
    `;
  }
}
